import React from "react";

export default function Footer(){
    return(
        <div id= "footer">
            Y-Tunnus 3342657-7
        </div>
    )
}